import moment from 'moment';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page } from '../shared';

import Select from 'react-select';

import { beginEditingUser, stopEditingUser, updateUser, fetchUser } from '../../actions/users';

const TENURE_OPTIONS = [{
  label: 'No selection',
  value: -1
},{
  label: 'Less than 1 year',
  value: 1
},{
  label: '1-4 Years',
  value: 2
},{
  label: '5-10 Years',
  value: 3
},{
  label: '10+ Years',
  value: 4
}];

const GENDER_OPTIONS = [{
  label: 'No selection',
  value: null
},{
  label: 'Male',
  value: 'male'
},{
  label: 'Female',
  value: 'female'
}];

const EDUCATION_OPTIONS = [{
  label: 'No selection',
  value: -1
},{
  label: 'No formal education',
  value: 1
},{
  label: 'Some high school',
  value: 2
},{
  label: 'High school / GED',
  value: 3
},{
  label: 'Some college',
  value: 4
},{
  label: 'Vocational qualification',
  value: 5
},{
  label: 'Bachelor\'s Degree',
  value: 6
},{
  label: 'Master\'s Degree',
  value: 7
},{
  label: 'Doctorate or higher',
  value: 8
}];

const EXPERIENCE_OPTIONS = [{
  label: 'No selection',
  value: -1
},{
  label: 'No prior experience',
  value: 0
},{
  label: 'Less  1 year',
  value: 1
},{
  label: '1-4 Years',
  value: 2
},{
  label: '5-10 Years',
  value: 3
},{
  label: '10+ Years',
  value: 4
}];

const INITIAL_STATE = {
  firstName: '',
  lastName: '',
  email: '',
  title: '',
  tenure: -1,
  education: -1,
  experience: -1,
  gender: null,
}
class ProfilePage extends Component {

  state = INITIAL_STATE;

  userDataFromProps(){
    return this.props.isViewingUser ? this.props.viewingUser : this.props.user;
  }

  updateUserDataInState(userData){

    if(!userData){
      return;
    }

    // console.log('updating user data in state with: ', userData);

    const { firstName, lastName, email } = userData;
    const { title, tenure, education, experience, gender } = userData.profileMeta || {};

    this.setState({
      firstName,
      lastName,
      email,
      title: title || '',
      tenure: tenure || -1,
      education: education || -1,
      experience: experience || -1,
      gender: gender || null,
    });
  }

  initializeEditingUser(userToEdit){
    //if we have user data to edit, but are not yet editing
    if(!this.props.editingUser.editing && userToEdit){
      this.props.beginEditingUser(userToEdit);
    }
  }

  componentWillMount(){

    // console.log('props for profile page: ', this.props);

    const userDataFromProps = this.userDataFromProps();

    this.updateUserDataInState(userDataFromProps);
    this.initializeEditingUser(userDataFromProps);
  }
  componentWillUnmount(){
    this.props.stopEditingUser();
  }
  componentWillReceiveProps(nextProps){

    // console.log('profile received props: ', nextProps);


    //don't update local on syncing
    if(nextProps.editingUser.syncingWithServer){
      return;
    }

    if(!this.props.isViewingUser){
      //if not editing yet, set up original data
      this.updateUserDataInState(nextProps.user);
      this.initializeEditingUser(nextProps.user);
    }
    else{
      this.updateUserDataInState(nextProps.viewingUser);
      this.initializeEditingUser(nextProps.viewingUser);
    }
  }

  renderFormMessage(){
    return null;
  }

  profileIsDirty(){
    const userDataFromProps = this.userDataFromProps();

    if(!userDataFromProps){
      return false;
    }

    const { firstName, lastName, email, title, tenure, experience, education, gender } = this.state;


    if(!userDataFromProps.profileMeta){
      userDataFromProps.profileMeta = {
        title: INITIAL_STATE.title,
        tenure: INITIAL_STATE.tenure,
        education: INITIAL_STATE.education,
        experience: INITIAL_STATE.experience,
        gender: INITIAL_STATE.gender,
      }
    }

    console.log('profile dirty? ', userDataFromProps.profileMeta.gender, gender);

    if( userDataFromProps.firstName !== firstName ||
        userDataFromProps.lastName !== lastName ||
        userDataFromProps.email !== email ||
        userDataFromProps.profileMeta.title !== title ||
        userDataFromProps.profileMeta.tenure !== tenure ||
        userDataFromProps.profileMeta.experience !== experience ||
        userDataFromProps.profileMeta.education !== education ||
        userDataFromProps.profileMeta.gender !== gender
    ){
      return true;
    }
    else{
      return false;
    }
  }

  getOptionForValue(options, value){
    return _.find(options, option => {
      return option.value === value;
    });
  }

  renderEditProfileForm(){

    const { firstName, lastName, email, title, tenure, education, experience, gender } = this.state;

    const { titleEnabled, tenureEnabled, educationEnabled, experienceEnabled, genderEnabled } = ((this.props.organization || {}).profileOptions || {});

    //EMAIL dislabed for now, TODO add change functionality - see https://firebase.google.com/docs/auth/web/manage-users
    return (
      <form className="velocity-form">
        {this.renderFormMessage()}
        <div className="form-group">
          <div className="input-group half-width">
            <label htmlFor="velocity-user-first-name">First name</label>
            <input
              ref={input => { this.firstNameInput = input; }}
              id="velocity-user-first-name"
              autoComplete="off"
              type="text"
              value={firstName}
              onChange={e => {this.setState({ firstName: e.target.value })}}
              />
          </div>
          <div className="input-group half-width">
            <label htmlFor="velocity-user-last-name">Last name</label>
            <input
              id="velocity-user-last-name"
              autoComplete="off"
              type="text"
              value={lastName}
              onChange={e => {this.setState({ lastName: e.target.value })}}
              />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="velocity-user-email">Email Address</label>
          <input
            id="velocity-user-email"
            type="email"
            className="fs-block"
            value={email}
            disabled={true}
            onChange={e => {this.setState({ email: e.target.value })}}
            />
        </div>
        <div className="form-section">
          <div className="form-group">
            {titleEnabled &&
              <div className="input-group quarter-width">
                <label htmlFor="velocity-user-title">Title</label>
                <input
                  id="velocity-user-title"
                  autoComplete="off"
                  type="text"
                  className="fs-block"
                  value={title || ''}
                  onChange={e => {this.setState({ title: e.target.value })}}
                  />
              </div>
            }
            {tenureEnabled &&
              <div className="input-group quarter-width">
                <label htmlFor="velocity-user-tenure">Tenure</label>
                  <Select
                    classNamePrefix={'react-select'}
                    className='react-select-container fs-block velocity-user-tenure'
                    value={this.getOptionForValue(TENURE_OPTIONS, tenure)}
                    options={TENURE_OPTIONS}
                    onChange={(option) => { this.setState({ tenure: option.value }); }}
                    isSearchable={true}
                  />
              </div>
            }
            {educationEnabled &&
              <div className="input-group quarter-width">
                <label htmlFor="velocity-user-education">Education</label>
                  <Select
                    classNamePrefix={'react-select'}
                    className='react-select-container fs-block velocity-user-education'
                    value={this.getOptionForValue(EDUCATION_OPTIONS, education)}
                    options={EDUCATION_OPTIONS}
                    onChange={(option) => { this.setState({ education: option.value }); }}
                    isSearchable={true}
                  />
              </div>
            }
            {experienceEnabled &&
              <div className="input-group quarter-width">
                <label htmlFor="velocity-user-experience">Prior Sales Experience</label>
                  <Select
                    classNamePrefix={'react-select'}
                    className='react-select-container fs-block velocity-user-experience'
                    value={this.getOptionForValue(EXPERIENCE_OPTIONS, experience)}
                    options={EXPERIENCE_OPTIONS}
                    onChange={(option) => { this.setState({ experience: option.value }); }}
                    isSearchable={true}
                  />
              </div>
            }
            {genderEnabled &&
              <div className="input-group quarter-width">
                <label htmlFor="velocity-user-gender">Gender</label>
                  <Select
                    classNamePrefix={'react-select'}
                    className='react-select-container fs-block velocity-user-gender'
                    value={this.getOptionForValue(GENDER_OPTIONS, gender)}
                    options={GENDER_OPTIONS}
                    onChange={(option) => { this.setState({ gender: option.value }); }}
                    isSearchable={true}
                  />
              </div>
            }
          </div>
        </div>
      </form>
    )
  }

  revertChanges(){
    const userDataFromProps = this.userDataFromProps();

    const { firstName, lastName, email } = userDataFromProps;
    const { title, tenure, education, experience, gender } = (userDataFromProps.profileMeta || {});

    this.setState({
      firstName,
      lastName,
      email,
      title,
      tenure,
      education,
      experience,
      gender,
    });
  }

  saveChanges(){
    const { firstName, lastName, email, title, tenure, education, experience, gender } = this.state;

    const dataToSave = {
      ...this.userDataFromProps(),
      firstName,
      lastName,
      email,
      profileMeta: {
        title: title || '',
        tenure: tenure || 0,
        education: education || 0,
        experience: experience || 0,
        gender: gender || null,
      }
    }

    console.log('data to save: ', dataToSave);

    //console.log('saving...', dataToSave);

    this.props.updateUser(dataToSave, () => {

      //if own profile, these change sync automatically
      if(this.props.isViewingUser){
        //refetch "viewinguser" data
        this.props.fetchUser(dataToSave._id);
      }
      else{
        //do nothing
      }
    });
  }

  renderPageTitle(){
    const userData = this.userDataFromProps();

    if(!userData){ return null; }

    const { firstName, lastName, _deleted, deletedOn } = userData;

    return (
      <div className="page-title no-subheader">
        {_deleted &&
          <h6 className="color-danger" style={{marginTop: 0, marginBottom: 0}}>Archived {moment(deletedOn.toDate()).fromNow()}</h6>
        }
        <h1>{this.props.isViewingUser ? `${firstName}'s` : 'Your'} Profile</h1>
      </div>
    )
  }

  render(){

    const userData = this.userDataFromProps();

    const loading = !userData;

    const savingChanges = this.props.editingUser && this.props.editingUser.syncingWithServer;

    // console.log(this.state.editingUser);
    // console.log('savingChanges: ', savingChanges);
    //
    // console.log('loading: ', loading);
    // console.log('userData: ', userData);

    return (
      <Page pageClass="profile" loading={loading}>
        {this.renderPageTitle()}
        <div className="page-actions">
          <button onClick={this.saveChanges.bind(this)} className="button primary" disabled={!this.profileIsDirty() || savingChanges}>{savingChanges ? 'Saving...' : 'Save Changes'}</button>
          {this.profileIsDirty() &&
            <button onClick={this.revertChanges.bind(this)} className="button grey-button">Cancel</button>
          }
        </div>
        <div className="page-content">
          {this.renderEditProfileForm()}
        </div>
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    organization: state.organization.data,
    viewingUser: state.viewingUser.data,
    editingUser: state.editingUser,
  }
}

export default connect(mapStateToProps, { beginEditingUser, stopEditingUser, updateUser, fetchUser })(ProfilePage);



// WEBPACK FOOTER //
// ./src/components/profile/index.js